// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Footer_wrapper__WYHWo","footerNavigationWrapper":"Footer_footerNavigationWrapper__dINad","footerNavigationItem":"Footer_footerNavigationItem__CuLNS"};